import { useTranslation } from "react-i18next";

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="relative overflow-hidden py-12 px-4">
      <div className="absolute top-0 left-0 w-full h-1/5 bg-gradient-to-b from-black via-black/70 to-transparent backdrop-blur-sm z-[5]" />

      <div className="relative z-20 w-full max-w-6xl mx-auto text-white text-center px-6 mt-6 sm:mt-16 md:mt-20">
        <h2
          className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400"
          data-aos="fade-down"
        >
          {t("about.title")}
        </h2>

        {/* Separatore */}
        <div
          className="w-36 sm:w-40 md:w-48 h-1 mx-auto mb-12 sm:mb-16 bg-gradient-to-r from-transparent via-purple-300 to-transparent"
          data-aos="fade-up"
        ></div>

        <div className="mt-6 md:mt-8 p-2">
          <p
            className="text-base sm:text-base md:text-lg text-gray-200 leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            {t("about.description")}
          </p>
        </div>

        <div className="flex flex-col leading-none cursor-pointer select-none mt-8 sm:mt-12">
          <span className="logo-vision">VISION</span>
          <span className="logo-design">DESIGN</span>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
